import { t } from "i18next";
import React from "react";

const SubTitleRow = ({ title }) => {
  return <div className="hayley-mb-2 hayley-w-full hayley-text-xs hayley-font-semibold hayley-text-custom-4">{t(title)}</div>;
};

export default SubTitleRow;
